import config from "../config.js";

const requestJson = async (url, fetchImpl) => {
  try {
    const response = await fetchImpl(url, { credentials: "include" });
    if (!response.ok) return null;

    return await response.json();
  } catch (error) {
    console.error("사용자 리뷰 노출 조건 확인 실패:", error);
    return null;
  }
};

export const getUserFeedbackStatus = async ({
  fetchImpl = fetch,
  serverUri = config.serverUri,
} = {}) => {
  const data = await requestJson(
    `${serverUri}/private/users/like`,
    fetchImpl,
  );

  return typeof data?.like === "boolean" ? data.like : null;
};

export const shouldRequestResultFeedback = async (options = {}) => {
  const feedbackStatus = await getUserFeedbackStatus(options);
  if (feedbackStatus === null) return null;

  return feedbackStatus === false;
};
